import { render, staticRenderFns } from "./Kabinet.vue?vue&type=template&id=6a780b5e&scoped=true&"
import script from "./Kabinet.vue?vue&type=script&lang=js&"
export * from "./Kabinet.vue?vue&type=script&lang=js&"
import style0 from "./Kabinet.vue?vue&type=style&index=0&id=6a780b5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a780b5e",
  null
  
)

export default component.exports